import getStore from '../store/store';
import { initSearchDatapoint } from '../actions/searchStoreActions';
import { mutator } from 'satcheljs';
import { PerformanceDatapoint } from 'owa-analytics';

export let initSearchDatapointMutator = mutator(initSearchDatapoint, actionMessage => {
    let store = getStore();
    let newDatapoint = new PerformanceDatapoint('SearchEndToEnd');
    newDatapoint.addCustomData({
        queryLength: actionMessage.queryLength,
    });

    store.searchEndToEndDatapoints.push(newDatapoint);
});
